import React, { useCallback, useState } from 'react';
import { Col, Row, Select, Typography } from 'antd';
import { useParams } from '@common/hooks';
import debounce from 'lodash/debounce';
import { AppContent, Icon, Navigate } from '@common/components';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { CreateStaffingRequestSelectTemplateTable } from './create-staffing-request-select-template-table';
import { useCurrentEntity } from '@identity/hooks';

const { Title } = Typography;

const STAFFING_REQUEST_TYPES = {
  long_term: 'long_term',
  on_demand: 'on_demand',
};

export function CreateStaffingRequestSelectTemplatePage() {
  const [searchQuery, setSearchQuery] = useState('');
  const { tabKey } = useParams();
  const staffingRequestType = STAFFING_REQUEST_TYPES[tabKey];
  const currentEntity = useCurrentEntity();

  const onDemandEnabled = currentEntity.onDemandEnabled ?? true;

  const redirectToLongTerm =
    (staffingRequestType !== 'long_term' && !onDemandEnabled) ||
    !staffingRequestType;

  const handleSearch = (newSearch) => {
    if (newSearch.length >= 2 || newSearch.length === 0) {
      setSearchQuery(newSearch);
    }
  };

  const debounceSearch = useCallback(debounce(handleSearch, 300), []); // eslint-disable-line react-hooks/exhaustive-deps

  setBreadcrumbs([
    {
      name: 'Staffing',
      path: `/works/staffing_requests/requests/${tabKey}`,
    },
    {
      name: 'Request',
      path: `/works/staffing_requests/templates/${tabKey}`,
    },
  ]);

  const title = (
    <>
      Select {tabKey === 'on_demand' ? 'an on demand' : 'a long term'} staffing
      template.
    </>
  );

  return (
    <>
      {redirectToLongTerm && (
        <Navigate to="/works/staffing_requests/templates/long_term" />
      )}
      <AppContent className="CreateStaffingRequestSelectTemplatePage">
        <div className="template-container">
          <Row gutter={[0, 14]} justify="center" className="step-header">
            <Col span={24}>
              <div className="ant-descriptions-title">Step 1 of 2</div>
            </Col>
            <Col span={24}>
              <Title level={2} className="step-title">
                {title}
              </Title>
            </Col>
          </Row>
          <Row justify="center" gutter={4}>
            <div className="search-box-container">
              <Col>
                <Select
                  placeholder={
                    <>
                      <Icon kind="light" icon="search" size="sm" />{' '}
                      <span>Search templates by keywords...</span>
                    </>
                  }
                  allowClear
                  showSearch={true}
                  defaultActiveFirstOption={false}
                  onSearch={debounceSearch}
                  showArrow={false}
                  notFoundContent={null}
                  style={{ width: '100%' }}
                />
              </Col>
            </div>
          </Row>
          <Row
            justify="center"
            gutter={{
              xs: 8,
              md: 16,
            }}
          >
            <CreateStaffingRequestSelectTemplateTable
              searchQuery={searchQuery}
              staffingRequestType={staffingRequestType}
            />
          </Row>
        </div>
      </AppContent>
      <style jsx>{`
        .search-box-container {
          flex-grow: 1;
          padding-right: 20px;
          padding-left: 20px;
          padding-top: 20px;
          height: 72px;
          background-color: #edf0f1;
        }
        .template-container {
          width: 100%;
          margin: 0 auto;
          max-width: 1100px;
        }
      `}</style>
    </>
  );
}
